import { useState, useEffect } from "react";

const FieldingStatsTable = ({
  tableContent,
  selectedFilter,
  selectedYear,
  selectedLanguage = "en", // default to English
}) => {
  const [dataColumns, setDataColumns] = useState([]);

  useEffect(() => {
    let columns = [
      {
        key: "most_catches",
        label: "Catches",
        highlight: "Most Catches",
      },
      {
        key: "matches_played",
        label: "Matches",
      },
      {
        key: "most_run_outs",
        label: "Run Outs",
        highlight: "Most Run Outs",
      },
      {
        key: "most_dismissals",
        label: "Dismissals",
        highlight: "Most Dismissals",
      },
    ];

    const selectedIndex = columns.findIndex(
      (item) => item.highlight === selectedFilter
    );

    if (selectedIndex > 0) {
      const [selectedColumn] = columns.splice(selectedIndex, 1);
      columns.unshift(selectedColumn);
    }

    setDataColumns(columns);
  }, [selectedFilter, selectedLanguage]);
  const sortedTableContent = [...(tableContent ?? [])]
    .sort((a, b) => {
      if (!selectedFilter) return 0;

      const parseValue = (val) => {
        if (val == null) return -Infinity;

        const cleaned = val.toString().replace(/\*/g, "");
        const num = parseFloat(cleaned);
        return isNaN(num) ? -Infinity : num;
      };

      const aVal = parseValue(a[selectedFilter]);
      const bVal = parseValue(b[selectedFilter]);

      return bVal - aVal; // Descending order
    })
    .slice(0, 5);

  return (
    <div className="relative">
      <div className="md:w-full md:overflow-hidden overflow-x-auto">
        <div className="flex py-3 min-w-[800px]">
          <div className="flex w-[35%] text-[#FFFFFF] text-[12px] font-[500]">
            <div className="text-[14px] font-[400] text-[#000000] dark:text-white w-[20%] text-center">
              {selectedLanguage === "hi" ? "स्थिति" : "Pos"}
            </div>
            <div className="text-[14px] font-[400] text-[#000000] dark:text-white w-[80%]">
              {selectedLanguage === "hi" ? "खिलाड़ी का नाम" : "Player Name"}
            </div>
          </div>
          <div className="w-[65%] text-center">
            <div className="flex items-center justify-around">
              {dataColumns &&
                dataColumns.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={`text-[14px] ${selectedFilter === item?.highlight
                        ? "font-bold"
                        : "font-[400]"
                        } text-[#000000] dark:text-white w-[24%]`}
                    >
                      {item?.label}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>

        {sortedTableContent &&
          sortedTableContent.map((value, index) => (
            <div
              className={`flex ${index % 2 == 0
                ? "bg-gray-200 dark:bg-gray-800"
                : "bg-white dark:bg-[#1F1F1F]"
                } py-3 min-w-[800px] items-center`}
              key={index}
            >
              <div className="flex w-[35%] text-[#FFFFFF] text-[12px] font-[500] items-center">
                <div className="text-[14px] font-[400] text-[#525358] dark:text-[#FFFFFF80] w-[20%] text-center">
                  {index + 1}
                </div>
                <div className="text-[14px] font-[400] text-[#525358] dark:text-[#FFFFFF80] w-[80%]">
                  <div className="flex">
                    <img
                      width={"50px"}
                      height={"50px"}
                      className="w-[50px] h-[50px] mr-3 rounded-full"
                      src={`https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/${value?.player_id}.png`}
                      onError={(e) => {
                        e.target.src =
                          "https://akm-img-a-in.tosshub.com/sites/sports/ipl/resources_live/images/players_img/ipl_2025/0.png";
                      }}
                    />
                    <div className="font-semibold text-[#525358] dark:text-[#FFFFFFCC]">
                      {value.player_name}
                      <div className="font-normal">
                        {value?.team_short_name ?? "-"}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-[65%] text-center">
                <div className="flex items-center justify-around">
                  {dataColumns &&
                    dataColumns.map((item, index) => {
                      return (
                        <div
                          key={index}
                          className={`text-[14px] ${selectedFilter === item?.highlight
                            ? "font-bold text-[#000] dark:text-white"
                            : "font-[400] text-[#525358] dark:text-[#ffffffcc]"
                            } dark:text-[#FFFFFF80] w-[24%]`}
                        >
                          {value[item?.key] ?? "-"}
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>
          ))}
      </div>


      <div className="flex justify-center w-full my-3 pb-3">
        {sortedTableContent && sortedTableContent.length > 0 ? (
          <a
            href={selectedYear == "2025" ? `/sports/ipl/fielding-records` : `/sports/ipl/fielding-records-${selectedYear}`}
          >
            <div className="flex items-center gap-2 rounded-full h-10 w-auto px-4 bg-primary mt-4 text-white dark:text-[#1f1f1f] justify-center">
              <img src="https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/send.png" alt="View" className="h-5 w-5" />
              <span>View All</span>
            </div>
          </a>
        ) : (
          <div className="flex items-center gap-2 rounded-full h-10 w-auto px-4 bg-gray-400 mt-4 text-white justify-center cursor-not-allowed">
            <span>Data Not Available!</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default FieldingStatsTable;
